export default {
  route: {
  },
  login: {
    site: 'SITE',
    title: 'Login Title',
    logIn: 'Log in',
    username: 'Username',
    password: 'Password',
    license: 'license'
  }
}
